// extracted by css-extract-rspack-plugin
export default {"modalConfirmBackdrop":"TJFr5BqGP68OSKBu","modalConfirm":"owuZGSZHkOY7Q1mh","modalFooter":"u2BMjPq2rSU2EZiR"};